<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "OnlineSınav",
  created() {
    setTimeout(() => {
      /* Browser Check */
      if (this.$store.state.auth.student.userAgentDetail != null) {
        let browser = this.$store.state.auth.student.userAgentDetail.browser
        if(browser == 'Internet Explorer 11' || browser == 'Internet Explorer' || browser == 'Edge' || browser == 'Safari') {
          $.confirm({ // eslint-disable-line
            title: 'Uyarı!',
            content: 'Online Sınav projesinin doğru çalışması için ve bu uygulamadan en doğru deneyimi elde etmen için <a href="https://www.google.com/intl/tr_tr/chrome/" target="_blank">Google Chrome</a> gibi modern bir tarayıcı kullanman gerekir.' + ' <br> <strong>Kullandığın tarayıcı:</strong>' + browser,
            type: 'red',
            typeAnimated: true,
            backgroundDismissAnimation: 'glow',
            buttons: {
              test: {
                isHidden: true,
                isDisabled: true,
              },
            }
          })
        }
      }
    }, 2000)
  }
}
</script>